module.exports = __webpack_public_path__ + "c4554bef502902a0a785e9cb698a0c37.png";